import { render, staticRenderFns } from "./FiltroSaudacao.vue?vue&type=template&id=17cccc3b&"
import script from "./FiltroSaudacao.vue?vue&type=script&lang=js&"
export * from "./FiltroSaudacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports